import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CopyToClipboardButton } from '../../components/CopyToClipboardButton';
import { locations } from '../../routes/locations';
import { BatchExecutionTable } from './BatchExecutionTable';
import { FeeBatchTable } from './FeeBatchTable';

export function BatchExecution() {
  const executionId = String(useParams().id);
  const navigate = useNavigate();

  useEffect(() => {
    if (!executionId) {
      return navigate(locations.batchExecutionList(), { replace: true });
    }
  }, [executionId]);

  return (
    <Container component="main" maxWidth="xl">
      <Box sx={{ pb: 5 }}>
        <Typography color="text.primary" variant="h4" sx={{ pb: 5 }}>
          Batch Execution Details
        </Typography>
      </Box>

      <Grid container rowSpacing={2}>
        <Grid item container flexDirection="column" component={Paper} sx={{ p: 4 }} rowSpacing={2}>
          <Grid item container>
            <Grid item xs={6}>
              <Typography variant="subtitle1">Execution Id</Typography>
            </Grid>
            <Grid item xs={6}>
              <CopyToClipboardButton value={executionId} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item sx={{ width: '100%' }}>
          <BatchExecutionTable executionId={executionId} />
        </Grid>
        <Grid item sx={{ width: '100%' }}>
          <FeeBatchTable executionId={executionId} />
        </Grid>
      </Grid>
    </Container>
  );
}
